import { useState } from "react";
import { LuLoaderCircle, LuRotateCcw, LuX } from "react-icons/lu";
import { useChatMessagesActions } from "../../../view_stores/chat_messages/useChatMessagesStore";
import { useRollbackHandlerActions } from "../../../view_stores/useRollbackHandlerStore";

export default function ProjectRollbackConfirmation() {
  const { rollbackConfirmed, reset } = useRollbackHandlerActions();
  const { setShouldAutoScroll } = useChatMessagesActions();

  const [isRollbacking, setIsRollbacking] = useState(false);

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col gap-2">
        <p>
          All changes made after the selected checkpoint will be permanently
          lost and cannot be recovered.
        </p>
        <p>Proceed with rollback?</p>
      </div>
      <div className="flex justify-center gap-8 w-full max-w-[400px]">
        <button
          className="w-full flex items-center justify-center 
              gap-2 py-2 bg-white dark:bg-[#272829]
              hover:brightness-125 hover:cursor-pointer
              transition-all duration-300 rounded"
          onClick={reset}
          disabled={isRollbacking}
        >
          <LuX />
          <span>Cancel</span>
        </button>
        <button
          className="w-full flex items-center justify-center 
          gap-2 py-2 bg-primary-blue
          hover:brightness-125 hover:cursor-pointer
          transition-all duration-300 rounded"
          onClick={() => {
            rollbackConfirmed();
            setShouldAutoScroll(true);
            setIsRollbacking(true);
          }}
          disabled={isRollbacking}
        >
          {isRollbacking ? (
            <LuLoaderCircle className="animate-spin" size={20} />
          ) : (
            <>
              <LuRotateCcw />
              <span>Rollback now</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
